export enum DropdownType {
  DIALOG = "dialog",
  DROPDOWN = "dropdown",
}
